import Marquee from "react-fast-marquee";
import shareTransmissionImf from "../../assets/images/share-transmission.png";
import { fpRealaatedArticales } from "../../data/relatedArticale";
import Faq from "../Faq";
import Meta from "../Meta";

export default function ShareTransmission() {
  const faqItems = [
    {
      title: "What is share transmission?",
      content: (
        <strong>
          Share transmission is the legal process of transferring shares from a
          deceased shareholder to their legal heir(s) or nominee(s).
        </strong>
      ),
    },
    {
      title: "Is a succession certificate necessary?",
      content: (
        <strong>
          Yes, a succession certificate or probate is typically required to
          establish legal ownership before transmission can be processed.
        </strong>
      ),
    },
    {
      title: "How long does share transmission take?",
      content: (
        <strong>
          If all documents are in order, the process usually takes 2–4 weeks
          with RJSC and company coordination.
        </strong>
      ),
    },
  ];
  return (
    <>
      <Meta
        title="Share Transmission Process in Bangladesh | Transmission of shares"
        description="Transmission of shares occurs when the shares of a deceased share holder are inheritedThe process of transmitting shares involves transferring ownership from a deceased or incapacitated shareholder to their legal heir(s) or nominee."
        image={shareTransmissionImf}
        keywords="share transmission, shareholder death, succession certificate, RJSC Bangladesh, legal share transfer"
      />

      <div className="container-fluid hero-header bg-light py-5 mb-5">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <h1 className="display-4 mb-3 animated slideInDown">
                Share Transmission
              </h1>
            <p>The process of transmitting shares involves transferring ownership from a deceased or incapacitated shareholder to their legal heir(s) or nominee. This process differs from a share transfer, which involves a sale or gift of shares between living individuals. </p>
            </div>
            <div className="col-lg-6 animated fadeIn">
              <img
                className="img-fluid animated pulse infinite"
                style={{ animationDuration: "3s" }}
                src={shareTransmissionImf}
                alt="share-transmission-services"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Intro */}
      <div className="container-xxl py-5">
        <div className="container">
          <p className="color-text fs-5 mb-4">
            <b>What is Share Transmission?</b>
          </p>
          <p>
            Share transmission occurs when a shareholder passes away and their
            shares are transferred to their legal heirs or nominee. It’s a legal
            process that differs from voluntary share transfer. The legal heir
            must provide proof of entitlement such as a succession certificate,
            will, or court order.
            <br />
            <br />
            The process must comply with the Companies Act and must be properly
            documented with the company and the Registrar of Joint Stock
            Companies (RJSC) in Bangladesh.
          </p>

          <p className="color-text fs-5 mb-4">
            <b>Why is Share Transmission Important?</b>
          </p>
          <p>
            Proper share transmission ensures legal ownership of shares is
            transferred to rightful heirs, avoids disputes, and keeps the
            company shareholding records accurate. It’s essential for smooth
            business continuity, especially in private limited companies where
            shares cannot be traded freely.
          </p>
        </div>
      </div>

      {/* JK Services */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <img
                className="img-fluid"
                src={shareTransmissionImf}
                alt="share-transmission-process"
              />
            </div>
            <div className="col-lg-6">
              <div className="h-100">
                <p className="color-text fs-5 mb-4">
                  What services does ‘JK Associates’ provide for Share
                  Transmission?
                </p>
                <div className="d-flex align-items-center mb-2">
                  <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                  <span>
                    <b>Consultation: </b>We guide heirs through the legal and
                    procedural aspects of share transmission.
                  </span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                  <span>
                    <b>Document Drafting: </b>We prepare application forms,
                    affidavits, and board resolutions.
                  </span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                  <span>
                    <b>RJSC Compliance: </b>We handle filings and updates to the
                    official share register.
                  </span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                  <span>
                    <b>Board & Shareholder Coordination: </b>We assist companies
                    in conducting board meetings to approve transmission.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Process */}
      <div className="container-xxl py-0">
        <div className="container">
          <p className="color-text fs-5 mb-4">
            <b>Process of Share Transmission</b>
          </p>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Obtain death certificate of the shareholder</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>
              Get a succession certificate, probate, or legal heir certificate
            </span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Submit request with supporting documents to company</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Company passes board resolution for transmission</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Update RJSC and issue updated share certificates</span>
          </div>

          {/* Documents Required */}
          <p className="color-text fs-5 mb-4 mt-5">
            <b>Documents Required for Share Transmission</b>
          </p>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Death certificate</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Succession certificate / court order</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Share certificates</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Board resolution (drafted by JK Associates)</span>
          </div>
        </div>
      </div>

      {/* Related Articles */}
      <div className="container-xxl center-background1 py-5">
        <h2>Related Articles</h2>
        <Marquee className="marquee-container">{fpRealaatedArticales}</Marquee>
      </div>

      {/* FAQ Section */}
      <div className="container py-5 my-0">
        <h2 className="color-text text-center mb-4">Share Transmission FAQ</h2>
        <Faq items={faqItems} />
      </div>
    </>
  );
}
